import { render, staticRenderFns } from "./password-validate.vue?vue&type=template&id=42f04c3d&scoped=true&"
import script from "./password-validate.ts?vue&type=script&lang=ts&"
export * from "./password-validate.ts?vue&type=script&lang=ts&"
import style0 from "./password-validate.scss?vue&type=style&index=0&id=42f04c3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f04c3d",
  null
  
)

export default component.exports